export const SubscriptionRenewDetailsCommonFormName = 'subscription';

export enum SubscriptionRenewDetailsCommonFormFields {
  EffectiveDateFrom = 'effectiveDateFrom',
  EffectiveDateTo = 'effectiveDateTo',
}
